export default __webpack_public_path__ + "static/media/p12.7d273c37.jpg";